<div class="page-header">
  <div class="path">
    <a routerLink="/main" [queryParams]="{language: selectedLanguage}" class="home">{{'MAIN.HOME' | translate}}</a>
    <span *ngIf="getTopPathName(currMenu | async)">{{('MENU.MENU' + getTopPathName(currMenu | async)) | translate}}</span>
  </div>
  <div *ngIf="getSecondPathName(currMenu | async)" class="title">
    {{('MENU.MENU' + getSecondPathName(currMenu | async)) | translate}}
  </div>
</div>


<div class="sub-menu inner-wrap">
  <!-- <input type="text" class="selected-menu" value={{(currMenu$ | async)['page_name']}} readonly="true" (click)="isSubmenu=!isSubmenu;"/> -->
  <ul>
    <ng-container *ngFor="let item of getSecondNode(currMenu | async)['children']">
      <li *ngIf="item.use_yn === '1' && item.viewgroup_slevel <= level && item.viewgroup_elevel >= level && item.mainmenu_view_yn == '1'">
        <ng-container *ngIf="item.link_open_yn == 'N'">
          <ng-container *ngIf="item.link_url.includes('http'); else route">
            <a [href]="item.link_url" target="_blank">
              <span *ngIf="item.seq" [innerHTML]="('MENU.MENU' + item.seq) | translate"></span>
            </a>
          </ng-container>
          <ng-template #route>
            <a [routerLink]="item.link_url" target="_blank">
              <span *ngIf="item.seq" [innerHTML]="('MENU.MENU' + item.seq) | translate"></span>
            </a>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="item.link_open_yn == 'C'">
          <a class="cp" [ngClass]="{active: active_seq == item.seq}" (click)="goLink(item)">
            <span *ngIf="item.seq" [innerHTML]="('MENU.MENU' + item.seq) | translate"></span>
          </a>
        </ng-container>
      </li>
    </ng-container>
  </ul>
</div>
